import axios from "axios";
import { AccountType } from "shared/types/accounts";

export async function connectSnapChatAccount({
  login,
  profilePictureUrl,
}: {
  login: string;
  profilePictureUrl: string;
}): Promise<AccountType> {
  const {
    data: { data },
  } = await axios.post("/accounts/sc", {
    login,
    profilePictureUrl,
    platformType: "SC",
  });
  return data;
}
